<template>
    <section class="content" v-show="isShowingHomeDuplicateVersions">

        <div class="content-section-close" @click="manegeView(false)"></div>

        <div id="mySidenav" class="sidenav p-3 pt-4 mt-4 z-10">

            <br />

            <b-button variant="light" @click="manegeView(false)" class=" d-flex align-items-center">
                <i class="fa fa-chevron-left p-0 mr-2"></i>
                Cancelar proceso
            </b-button>

            <b-form @submit.prevent="onHandleDuplicateVersion" data-vv-scope="formDuplicateVersion">

                <b-card no-body class="mt-3">
                    <b-card-body>
                        <b-card-title class="text-primary">Duplicación de ediciones del SGA</b-card-title>
                        <b-card-sub-title class="mb-2">Duplicación ediciones, Este proceso puede tomar varios
                            minutos.</b-card-sub-title>

                        <!-- Formulario -->
                        <b-row class="mt-4">

                            <!-- Seleccionar edición -->
                            <b-col md="3">
                                <b-form-group>
                                    <label>Duplicar <span class="text-danger">*</span></label>
                                    <el-select v-model="newVersion.version_to_duplicate" name="version_to_duplicate">
                                        <el-option v-for="item in getAvailableVersions" :key="item.id"
                                            :label="item.version" :value="item.id" />
                                    </el-select>
                                    <span class="text-danger small"
                                        v-text="errors.first('formDuplicateVersion.version_to_duplicate')" />
                                </b-form-group>
                            </b-col>

                            <!-- Fecha de publicación -->
                            <b-col md="5">
                                <b-form-group>
                                    <label>Fecha de publicación <span class="text-danger">*</span></label>
                                    <b-form-input v-model="newVersion.date_of_publication" name="date_of_publication"
                                        type="date" class="form-control" v-validate="'required'" :max="currentDate"
                                        data-vv-as=" " />
                                    <span class="text-danger small"
                                        v-text="errors.first('formDuplicateVersion.date_of_publication')" />
                                </b-form-group>
                            </b-col>

                            <!-- edición -->
                            <b-col md="4">
                                <b-form-group>
                                    <label>Edición nueva <span class="text-danger">*</span></label>
                                    <b-form-input v-model="newVersion.version" type="text" class="form-control"
                                        name="version" v-validate="'required'" data-vv-as=" " />
                                    <span class="text-danger small"
                                        v-text="errors.first('formDuplicateVersion.version')" />
                                </b-form-group>
                            </b-col>

                            <b-col md="12">
                                <b-form-group>
                                <label>Sustancias no peligrosas <span class="text-danger">*</span></label>
                                <el-select v-model="newVersion.subs_not_dangers" clearable filterable multiple
                                            size="medium" placeholder="Seleccionar frases no peligrosas"
                                            name="subs_not_dangers" v-validate="'required'"
                                            data-vv-as=" ">
                                    <el-option v-for="item in subsNotDangers" :key="item.id"
                                            :label="item.name" :value="item.id" />
                                </el-select>
                                <span class="text-danger small"
                                        v-text="errors.first('formVersion.subs_not_dangers')" />
                                </b-form-group>
                            </b-col>

                            <b-col md="12">
                                <b-form-group>
                                    <label>Seleccionar países</label>
                                    <el-select v-model="newVersion.countries" clearable filterable multiple size="medium"
                                        placeholder="Seleccionar países" name="countries" v-validate="''"
                                        data-vv-as=" ">
                                        <el-option v-for="item in countriesWithConfig" :key="item.id" :label="item.name"
                                            :value="item.id" />
                                    </el-select>
                                    <span class="text-danger small" v-text="errors.first('formDuplicateVersion.countries')" />
                                    <small class="text-muted">
                                        Asocia de la edición actual con países.
                                    </small>
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-list-group flush small class="mt-3">
                            <b-list-group-item
                                class="rounded-sm px-6 d-flex justify-content-between align-items-center py-1"
                                v-for="item of itemsToDuplicate" :key="item.code" :disabled="!item.isCompleted">
                                <div class="d-flex align-items-center">
                                    <b-spinner small label="Spinning" v-if="item.isProcessing"></b-spinner>
                                    <i class="fa fa-check pl-1" v-else-if="item.isCompleted && !item.isProcessing"></i>
                                    <i class="fa fa-stop pl-1" v-else></i>
                                    <span class="ml-2">{{ item.title }}</span>
                                </div>
                            </b-list-group-item>
                        </b-list-group>

                    </b-card-body>

                    <b-alert show variant="light" class="text-center mx-4 my-0">
                        <i class="fa fa-info-circle pr-1"></i>
                        Una vez iniciado el proceso, no se podrá cancelar.
                    </b-alert>

                    <b-card-body class="d-flex justify-content-start align-items-center pl-4 my-0">
                        <b-button type="submit" class="card-link px-3 py-2 rounded text-white" variant="info"
                            :disabled="loadingDuplicateVersion">
                            <i class="fa mr-2" :class="loadingDuplicateVersion ? 'fa-history' : 'fa-copy'"></i>
                            {{ loadingDuplicateVersion ? `DUPLICANDO EDICIÓN ${newVersion.version_to_duplicate}` :
                            'INICIAR PROCESO DE CLONACIÓN' }}
                        </b-button>
                    </b-card-body>
                </b-card>

            </b-form>

        </div>

    </section>
</template>
<script>

// Importaciones generales
import { mapState, mapMutations, mapActions } from 'vuex';
import moment from "moment";

// Componentes

export default {
    name: 'sgaConfigurationsDuplicateVersions',

    data() {
        return {
            itemsToDuplicate: [
                { code: '001', isProcessing: 0, isCompleted: 0, title: 'Edición.' },
                { code: '002', isProcessing: 0, isCompleted: 0, title: 'Sustancias no Peligrosas.' },
                { code: '003', isProcessing: 0, isCompleted: 0, title: 'Tipos de peligro.' },
                { code: '004', isProcessing: 0, isCompleted: 0, title: 'Categorías y sub categorías.' },
                { code: '005', isProcessing: 0, isCompleted: 0, title: 'Tipos de sub categorías.' },
                { code: '006', isProcessing: 0, isCompleted: 0, title: 'Tipos de consejos de prudencia.' },
                { code: '007', isProcessing: 0, isCompleted: 0, title: 'Consejos de prudencia (Frases P).' },
                { code: '008', isProcessing: 0, isCompleted: 0, title: 'Indicaciones de peligro (Frases H).' },
                { code: '009', isProcessing: 0, isCompleted: 0, title: 'Reglas de pictogramas.' },
                { code: '010', isProcessing: 0, isCompleted: 0, title: 'Reglas de consejos de prudencia (Frases P).' },
                { code: '011', isProcessing: 0, isCompleted: 0, title: 'Reglas de indicaciones de peligro (Frases H).' },
            ],
            currentDate: moment().format('YYYY-MM-DD')
        }
    },

    async created(){
      await this.getSubNotDangers();
      await this.getCountriesWithConfig();
    },

    computed: {

        ...mapState('sgaVersions', ['subsNotDangers']),
        ...mapState('sgaVersions', ['versionsSga']),
        ...mapState('countries', ['countriesWithConfig']),

        ...mapState('sgaConfigsDuplicateVersions', {
            isShowingHomeDuplicateVersions: 'isShowingHomeDuplicateVersions',
            loadingDuplicateVersion: 'loading',
            newVersion: 'newVersion',
        }),

        getAvailableVersions() {

            if (!(this.versionsSga && typeof this.versionsSga === 'object' && 'data' in this.versionsSga && this.versionsSga.data.length > 0)) {
                return []
            }

            return [...new Map(this.versionsSga.data.map(item => [item.id, item])).values()];
        }

    },

    methods: {

        ...mapActions('sgaVersions', ['getSubNotDangers', 'getVersionsSga']),
        ...mapActions('countries', ['getCountriesWithConfig']),
        ...mapActions('sgaConfigsDuplicateVersions', [
            'duplicateVersion'
        ]),

        ...mapMutations('sgaVersions', [
            'setDefaultFilterSgaVersions',
        ]),
        ...mapMutations('sgaConfigsDuplicateVersions', [
            'setIsShowingHomeDuplicateVersions',
            'resetNewVersion',
            'setNewVersion',
            'setLoading'
        ]),

        manegeView(action) {
            this.setIsShowingHomeDuplicateVersions(action);
        },

        async onHandleDuplicateVersion() {
            try {

                const isValid = await this.$validator.validateAll('formDuplicateVersion');
                if (!isValid) return;

                this.itemsToDuplicate = this.itemsToDuplicate.map(x => ({ ...x, isProcessing: 1 }))

                const payload = {
                    ...this.newVersion,
                    version_to_duplicate: this.newVersion.version_to_duplicate,
                    callback: this.onHandleCallbackDuplicateVersion
                }

                await this.duplicateVersion(payload)

            } catch (e) {                
                this.onHandleCallbackDuplicateVersion(false)
            }
        },

        async onHandleCallbackDuplicateVersion(status) {
            this.itemsToDuplicate = this.itemsToDuplicate.map(x => ({ ...x, isProcessing: 0, isCompleted: status }))

            if (status) {
                this.resetNewVersion();
                this.manegeView(false);

                this.setDefaultFilterSgaVersions();
                await this.getVersionsSga();
            }
        }

    },
}
</script>

<style scoped>
.content {
    position: absolute;
    right: 0;
    width: 102%;
    height: 100vh;
    overflow: auto;
    background: #ffffffba;
    top: -21px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.content-section-close {
    width: calc(100% - 479pt);
    height: 100vh;
}

.sidenav {
    height: 100vh;
    width: 600pt;
    position: fixed;
    z-index: 1;
    top: 0;
    right: 0;
    background-color: #fcfcfc;
    overflow-x: hidden;
    padding-top: 60px;
    -webkit-transition: 0.5s;
    transition: 0.5s;
    overflow-y: auto;
}
</style>